<template>
    <header id="header" class="default-header -bgWhite_"
            :class="{
                'open' : navBar,
                '-hide' : isHide,
                '-bgWhite' : !this.isLuxuryPage() ||  (startPosition !== 0 && !isHide)}">
        <div class="headerInner">
            <div class="logo" @click="removeAllCondition">
                <router-link :to="{name: 'Index'}">
                    <img src="../../assets/logo_pc.png" alt="JAPAN HERITAGE OFFICIAL SITE" class="-black -pc">
                    <img src="../../assets/logo_sp.png" alt="JAPAN HERITAGE OFFICIAL SITE" class="-black -sp">
                    <img src="../../assets/logo_white_pc.png" alt="JAPAN HERITAGE OFFICIAL SITE" class="-white -pc">
                    <img src="../../assets/logo_white_sp.png" alt="JAPAN HERITAGE OFFICIAL SITE" class="-white -sp">
                </router-link>
            </div>
            <div class="gNavTrigger" @click="navBarSwitch"><span></span></div>
            <div class="searchAndMenu">
                <div class="search">
                    <input class="form-control"
                           placeholder="Enter search terms"
                           v-model="$globalState.searchConditions.keyword"
                           @keyup.enter="searchButtonHasClicked">
                    <button class="search-icon"
                            @click="searchButtonHasClicked"
                            @keyup.enter="searchButtonHasClicked"
                            @keyup.space="searchButtonHasClicked">
                        <svg class="ico_zoom top" xmlns="http://www.w3.org/2000/svg"
                             width="16.905" height="16.905" viewBox="0 0 16.905 16.905">
                            <g transform="translate(0.375 0.375)">
                                <circle cx="5.965" cy="5.965" r="5.965" fill="none"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" stroke-width="1"/>
                                <line x2="5.5" y2="5.5" transform="translate(10.5 10.5)"
                                      stroke-linecap="round" stroke-linejoin="round"
                                      stroke-miterlimit="10" fill="none"/>
                            </g>
                        </svg>
                    </button>
                </div>
                <div class="menu">
                    <nav id="gNavi" @click="navBarSwitch">
                        <ul class="gNaviMain" @click="removeAllCondition">
                            <li><router-link :to="{name: 'About'}">About</router-link></li>
                            <li><router-link :to="{name: 'FullList'}">Full List</router-link></li>
                            <li><router-link :to="{name: 'PlanYourVisit'}">Itineraries</router-link></li>
                            <li><router-link :to="{name: 'LuxuryTravel'}">Luxury</router-link></li>
                            <li><router-link :to="{name: 'SpiritOfJapan4'}">Spirit of Japan</router-link></li>
                            <li><router-link :to="{name: 'DiscoverMore2'}">Discover</router-link></li>
                            <li><router-link :to="{name: 'Movies'}">Videos</router-link></li>
                        </ul>
                        <ul class="gNaviSub">
                            <li>
                                <router-link :to="{name: 'HelpfulInfo'}">Helpful Info</router-link>
                                <ul>
                                    <li>
                                        <router-link :to="{name: 'HelpfulInfo'}"
                                                     v-scroll-to="{
                                                            el: '#goInfo',
                                                            offset: -100
                                                            }">General Information
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name: 'HelpfulInfo'}"
                                                     v-scroll-to="{
                                                            el: '#goCulture',
                                                            offset: -100
                                                            }">Going to See Cultural Properties
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li><router-link :to="{name: 'PrivacyPolicy'}">Privacy Policy</router-link></li>
                            <li><router-link :to="{name: 'Copyright'}">Copyright</router-link></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import SearchEvent from "../Helper/SearchEvent";
export default {
    name: "DefaultHeader",
    mixins: [SearchEvent],
    data: function () {
        return {
            navBar: false,
            isHide: false,
            windowWidth: window.innerWidth,
            startPosition: 0,
        }
    },
    mounted: function () {

        // ロードイベント
        window.addEventListener('load', () => {
            this.adjustContentPt();
        });

        // リサイズイベント
        let resizeTimerId = null;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimerId);
            resizeTimerId = setTimeout(() => {
                this.getWindowWidth();
                this.adjustContentPt();
            }, 50);
        });

        // スクロールイベント
        window.addEventListener('scroll', this.scrollY);
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('scroll', this.scrollY);
    },
    methods: {
        navBarSwitch: function () {
            if (this.windowWidth <= 767) {
                this.navBar = !this.navBar;
            }
        },
        scroll: function () {
            scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        scrollY: function () {

            // 下にスクロールしたとき、ヘッダを隠す機能
            if (this.$route.path === '/' || this.isLuxuryPage()) {  // トップページとラグジュアリーページ（一覧/下層）のみ適用
                const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (currentPosition > this.startPosition && this.startPosition >= 0) {
                    this.isHide = true;
                } else {
                    this.isHide = false;
                }
                this.startPosition = currentPosition;
            }
        },
        isLuxuryPage: function(){

            // 正規表現
            let regexp = /\/luxurytravel\d*/;

            return regexp.test(this.$route.path);
        },
        getWindowWidth: function () {
            this.windowWidth = window.innerWidth;
        },
        adjustContentPt: function () {

            let elContents = document.getElementById("contents");

            if (elContents === null) return;

            // トップ以外だったら、ヘッダの高さをコンテンツのpadding-topに適用
            if (!elContents.classList.contains('top-page')) {
                let h = document.getElementById('header').clientHeight;
                document.getElementById('contents').style.paddingTop = h + 'px';
            }
        }
    },
    watch: {
        $route:function () {
            this.navBar = false;
            this.isHide = false;
            this.startPosition = 0;
        }
    }
}
</script>

<style src="./DefaultHeader.scss" lang="scss" scoped />
